<div class="nsd">
  <button class="nsd__close" type="button" aria-label="Close" (click)="close()">
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" fill="currentColor"/>
    </svg>
  </button>

  <div class="nsd__content">
    <img
      class="nsd__gif"
      [src]="imageSrc"
      alt="Not submitted"
      (error)="onImageError()" />
    <p class="nsd__message">Record was not submitted</p>
  </div>
</div>
